import "./sobre.css";
import logo from "./assets/Logo-Gerais-Branco.png";

const Sobre = () => {
  return (
    <section class="geraisnet-sobre-section" id="sobre">
      <div class="geraisnet-sobre-container">
        <div class="geraisnet-sobre-logo-central">
          <img src={logo} alt="Gerais Net Logo" className="logo-img" />
        </div>

        <div class="geraisnet-text-container">
          <h3 class="geraisnet-section-subtitle">Quem Somos</h3>
          <h2 class="geraisnet-section-title">
            Conectando pessoas, impulsionando o futuro digital
          </h2>
          <p class="geraisnet-section-text">
            Há mais de meia década, a Gerais Net transforma a forma como pessoas
            e empresas se conectam. Combinamos tecnologia de ponta com
            atendimento humanizado para oferecer a melhor experiência em
            conectividade da região.
          </p>
        </div>

        <div class="geraisnet-diferenciais-grid">
          <div class="geraisnet-diferencial-card">
            <div class="geraisnet-card-icon">
              <i class="fas fa-cube"></i>
            </div>
            <h4 class="geraisnet-card-title">Tecnologia</h4>
            <p class="geraisnet-card-description">
              Infraestrutura de última geração com fibra óptica pura e
              equipamentos de alta performance.
            </p>
          </div>

          <div class="geraisnet-diferencial-card">
            <div class="geraisnet-card-icon">
              <i class="fas fa-shield-alt"></i>
            </div>
            <h4 class="geraisnet-card-title">Confiança</h4>
            <p class="geraisnet-card-description">
              Mais de meia decada de mercado e muitos clientes satisfeitos
              comprovam nossa seriedade.
            </p>
          </div>

          <div class="geraisnet-diferencial-card">
            <div class="geraisnet-card-icon">
              <i class="fas fa-bolt"></i>
            </div>
            <h4 class="geraisnet-card-title">Velocidade</h4>
            <p class="geraisnet-card-description">
              Conexão estável com latência mínima, ideal para streaming, gaming
              e trabalho remoto.
            </p>
          </div>
        </div>

        <div class="geraisnet-cta-container">
          <a href="#planos" class="geraisnet-btn-saiba-mais">
            <i class="fas fa-rocket"></i>
            Conheça Nossos Planos
          </a>
        </div>
      </div>
    </section>
  );
};
export default Sobre;
